import _ from 'lodash'
import i18n from '@/i18n/index'
import validators from '@/rules/index'
import format from 'string-format'
import { saveAs } from 'file-saver'
/**
 * @description 判读是否为外链
 * @param path
 * @returns {boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:|\/\/)/.test(path)
}

/**
 * @description 校验密码是否小于6位
 * @param value
 * @returns {boolean}
 */
export function isPassword(value) {
  return value.length >= 6
}

/**
 * @description 判断是否为数字
 * @param value
 * @returns {boolean}
 */
export function isInteger(value) {
  const reg = /^[0-9]*$/
  return reg.test(value)
}

/**
 * @description 判断是否是名称
 * @param value
 * @returns {boolean}
 */
export function isName(value) {
  const reg = /^[\u4e00-\u9fa5a-zA-Z0-9]+$/
  return reg.test(value)
}

/**
 * @description 判断是否为IP
 * @param ip
 * @returns {boolean}
 */
export function isIP(ip) {
  const reg =
    /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
  return reg.test(ip)
}

/**
 * @description 判断是否是传统网站
 * @param url
 * @returns {boolean}
 */
export function isUrl(url) {
  const reg =
    /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/**
 * @description 判断是否是小写字母
 * @param value
 * @returns {boolean}
 */
export function isLowerCase(value) {
  const reg = /^[a-z]+$/
  return reg.test(value)
}

/**
 * @description 判断是否是大写字母
 * @param value
 * @returns {boolean}
 */
export function isUpperCase(value) {
  const reg = /^[A-Z]+$/
  return reg.test(value)
}

/**
 * @description 判断是否是大写字母开头
 * @param value
 * @returns {boolean}
 */
export function isAlphabets(value) {
  const reg = /^[A-Za-z]+$/
  return reg.test(value)
}

/**
 * @description 判断是否是字符串
 * @param value
 * @returns {boolean}
 */
export function isString(value) {
  return typeof value === 'string' || value instanceof String
}

/**
 * @description 判断是否是数组
 * @param arg
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}

/**
 * @description 判断是否是端口号
 * @param value
 * @returns {boolean}
 */
export function isPort(value) {
  const reg =
    /^([0-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/
  return reg.test(value)
}

/**
 * @description 判断是否是手机号
 * @param value
 * @returns {boolean}
 */
export function isPhone(value) {
  const reg = /^1\d{10}$/
  return reg.test(value)
}

/**
 * @description 判断是否是身份证号(第二代)
 * @param value
 * @returns {boolean}
 */
export function isIdCard(value) {
  const reg =
    /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
  return reg.test(value)
}

/**
 * @description 判断是否是邮箱
 * @param value
 * @returns {boolean}
 */
export function isEmail(value) {
  const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
  return reg.test(value)
}

/**
 * @description 判断是否中文
 * @param value
 * @returns {boolean}
 */
export function isChina(value) {
  const reg = /^[\u4E00-\u9FA5]{2,4}$/
  return reg.test(value)
}

/**
 * @description 判断是否为空
 * @param value
 * @returns {boolean}
 */
export function isBlank(value) {
  return (
    value === null ||
    false ||
    value === '' ||
    value.trim() === '' ||
    value.toLocaleLowerCase().trim() === 'null'
  )
}

/**
 * @description 判断是否为固话
 * @param value
 * @returns {boolean}
 */
export function isTel(value) {
  const reg =
    /^(400|800)([0-9\\-]{7,10})|(([0-9]{4}|[0-9]{3})([- ])?)?([0-9]{7,8})(([- 转])*([0-9]{1,4}))?$/
  return reg.test(value)
}

/**
 * @description 判断是否为数字且最多两位小数
 * @param value
 * @returns {boolean}
 */
export function isNum(value) {
  const reg = /^\d+(\.\d{1,2})?$/
  return reg.test(value)
}

/**
 * @description 判断是否为json
 * @param value
 * @returns {boolean}
 */
export function isJson(value) {
  if (typeof value === 'string') {
    const obj = JSON.parse(value)
    return !!(typeof obj === 'object' && obj)
  }
  return false
}

export const isObject = (obj) =>
  obj !== null && obj && typeof obj === 'object' && !Array.isArray(obj)

export const includes = (collection, item) => {
  return collection.indexOf(item) !== -1
}

export const isEmptyArray = (arr) => {
  return Array.isArray(arr) && arr.length === 0
}

//区分Flagをチェックする
export const checkEnumFlag = (codeEnum) => {
  if (_.isEmpty(codeEnum)) {
    return false
  }

  if (codeEnum == '1') {
    return true
  }

  return false
}

//区別の比較
export const isEqualCodeEnum = (value, other) => {
  if (_.isEmpty(value)) {
    return false
  }
  return value == _.get(other, 'value')
}

export const warn = (message) => {
  console.warn(`[validate] ${message}`) // eslint-disable-line
}

/**
 * Parses a rule string expression.
 */
export const parseRule = (rule) => {
  let params = []
  const name = rule.split(':')[0]

  if (includes(rule, ':')) {
    params = rule.split(':').slice(1).join(':').split('|')
  }

  return { name, params }
}

/**
 * Normalizes the given rules expression.
 */
export const normalizeRules = (rules) => {
  // if falsy value return an empty object.
  if (!rules) {
    return {}
  }

  if (isObject(rules)) {
    // $FlowFixMe
    return Object.keys(rules).reduce((prev, curr) => {
      let params = []
      // $FlowFixMe
      if (rules[curr] === true) {
        params = []
      } else if (Array.isArray(rules[curr])) {
        params = rules[curr]
      } else if (isObject(rules[curr])) {
        params = rules[curr]
      } else {
        params = [rules[curr]]
      }

      // $FlowFixMe
      if (rules[curr] !== false) {
        prev[curr] = params
      }

      return prev
    }, {})
  }

  if (typeof rules !== 'string') {
    warn('rules must be either a string or an object.')
    return {}
  }

  return rules.split(',').reduce((prev, rule) => {
    const parsedRule = parseRule(rule)
    if (!parsedRule.name) {
      return prev
    }

    prev[parsedRule.name] = parsedRule.params
    return prev
  }, {})
}

/**
 * 将校验规则字符串转换为rules对象
 * @param {} valiate
 */
export function convertToRules(validate, label, type, trigger) {
  let rules = []
  let validateArrays = normalizeRules(validate)
  _.forOwn(validateArrays, function (value, key) {
    let dataType = type
    if (key == 'number') {
      dataType = 'number'
    }

    let rule = {
      [`${key}`]:
        value.length == 0
          ? true
          : isNum(value[0])
          ? Number(value[0])
          : value[0],
      trigger: trigger,
    }

    if (dataType) {
      rule.type = dataType
    }

    if (validators[key]) {
      rule.validator = validators[key](value)
    } else {
      let message = null
      if (key == 'required') {
        key = 'E00000001'
        message = format(
          i18n.t(`validateMessage.${key}`),
          label ? label : 'この項目'
        )
      }

      if (key == 'number') {
        key = 'E00000002'
        message = format(i18n.t(`validateMessage.${key}`))
      }

      if (key == 'max') {
        key = 'E00000019'
        message = format(i18n.t(`validateMessage.${key}`), value)
      }
      rule.message = message
    }
    rules.push(rule)
  })
  return rules
}
export function getNotifyList(data, notifyTypeEnum, ...params) {
  if (!data) return []
  let root = null
  if (_.isArray(data)) {
    root = data
  } else {
    root = [data]
  }
  let list = []
  root.filter((item) => {
    let colum = params[0]
    if (item?.[colum] && _.isString(item?.[colum])) {
      list.push(
        ...JSON.parse(item[colum]).filter(
          (row) => (row.notifyType = notifyTypeEnum.dln.code)
        )
      )
    }
    if (params[1] && item?.[params[1]] && _.isArray(item?.[params[1]])) {
      item[params[1]].filter((detil) => {
        if (detil?.[params[2]] && _.isString(detil?.[params[2]])) {
          list.push(
            ...JSON.parse(detil[params[2]]).filter(
              (row) => (row.notifyType = notifyTypeEnum.work.code)
            )
          )
        }
      })
    }
  })
  return list
}

export const getFieldValue = (field, source) => {
  if (_.isEmpty(field)) {
    return null
  }
  return _.get(source, field)
}

export const downloadBlob = (res, filename) => {
  const blob = new Blob([res])
  saveAs(blob, decodeURI(filename).replace(RegExp('%23', 'g'), '#'))
}
